import React from 'react';
import { ArrowBack } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

interface Props {
  label: string;
  onRedirect?: VoidFunction;
}

export const CardTitle = ({ label, onRedirect }: Props) => {
  return (
    <Stack direction="row" alignItems="center" gap="0.5rem">
      <Tooltip title="Go to VO details">
        <IconButton sx={{ padding: 0 }} onClick={onRedirect}>
          <ArrowBack sx={{ color: ({ palette }) => palette.common.black }} />
        </IconButton>
      </Tooltip>

      <Typography variant="h5" fontWeight={500}>
        {label}
      </Typography>
    </Stack>
  );
};
